'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createSelector } from 'reselect';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import IndustryOptions from '../constants/IndustryOptions';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { getAlphaSortedArrOfTextValPairsForSelect } from '../utils/utils';
import { getIndustryOptionText } from '../utils/langUtils';
var getIndustries = createSelector([function () {
  return IndustryOptions;
}], function (industryOptions) {
  var __ALL = industryOptions.ALL,
      __OTHER_INDUSTRY = industryOptions.OTHER_INDUSTRY,
      industries = _objectWithoutProperties(industryOptions, ["ALL", "OTHER_INDUSTRY"]);

  return getAlphaSortedArrOfTextValPairsForSelect(Object.keys(industries), getIndustryOptionText, IndustryOptions.ALL);
});
export default createReactClass({
  displayName: "IndustryDropdown",
  mixins: [PureRenderMixin],
  propTypes: {
    onGoodFilterChange: PropTypes.func.isRequired,
    industryFilter: PropTypes.string.isRequired
  },
  handleIndustryUpdate: function handleIndustryUpdate(event) {
    var params = {};
    params[GoodFiltersAndPage.INDUSTRY] = event.target.value;
    return this.props.onGoodFilterChange(params);
  },
  render: function render() {
    var industryFilter = this.props.industryFilter;
    return React.createElement(UIFormControl, {
      label: getIndustryOptionText('title')
    }, React.createElement(UISelect, {
      buttonUse: "transparent",
      className: "integrate-industry-dropdown p-x-0 p-top-0",
      menuWidth: 250,
      onChange: this.handleIndustryUpdate,
      options: getIndustries(),
      placeholder: getIndustryOptionText(industryFilter),
      placement: "bottom right",
      value: industryFilter
    }));
  }
});